import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { CheckCircle2, AlertCircle, Info, XCircle, X } from "lucide-react";
import "./style.css";

/**
 * Toast
 * Notificação flutuante no canto superior direito.
 * Suporta 4 tipos: success, error, warning, info.
 * Some automaticamente após `duration` ms.
 */
export default function Toast({
  message = "",
  type = "info",
  duration = 4000,
  onClose,
}) {
  const [exiting, setExiting] = useState(false);

  const handleClose = useCallback(() => {
    setExiting(true);
    setTimeout(() => {
      if (onClose) onClose();
    }, 250); // duração da animação de saída
  }, [onClose]);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, handleClose]);

  // Escolhe o ícone baseado no tipo
  const IconComponent = {
    success: CheckCircle2,
    error: XCircle,
    warning: AlertCircle,
    info: Info,
  }[type] || Info;

  return (
    <div
      className={`toast-container toast-${type} ${exiting ? "toast-exit" : ""}`}
      role="alert"
      aria-live="polite"
    >
      <div className="toast-icon-wrapper">
        <IconComponent />
      </div>
      <div className="toast-message">{message}</div>
      <button
        type="button"
        onClick={handleClose}
        className="toast-close"
        aria-label="Fechar notificação"
        title="Fechar"
      >
        <X />
      </button>
    </div>
  );
}

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["success", "error", "warning", "info"]),
  duration: PropTypes.number,
  onClose: PropTypes.func.isRequired,
};
